export const festival = require('./festival');
export const main = require('./main');
export const auxiliary = require('./auxiliary');
export const jury = require('./jury');